import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ConfigService, SharedConfigKey } from '@ddt-web/config-layer';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-disclosure',
	templateUrl: './disclosure.component.html',
	styleUrls: ['./disclosure.component.scss']
})
/**
 * Disclosure component which can be expanded and collapsed.
 * We show 4 lines of text, first 2 lines are prominent, the third line starts to fade and the forth line
 * is faded.
 *
 * Example(the children elements are not restricted to span, it can be other elements you want):
 * If we want to make it expandable:
 * <ac-disclosure>
 * 	<span dcrHTMLKey="EQUITY_ACTIVE_RISK_DECOMPOSITION_DISCLAIMER">
 * 	  EQUITY_ACTIVE_RISK_DECOMPOSITION_DISCLAIMER
 *  </span>
 * </ac-disclosure>
 *
 * If we want it to be static:
 * 1)
 * <ac-disclosure [isExpandable]="false"><span dcrHTMLKey="SNAPSHOT_DISCLOSURE">SNAPSHOT_DISCLOSURE></span></ac-disclosure>
 * 2)
 * <ac-disclosure class="text-condensed-14" dcrHTMLKey="SNAPSHOT_DISCLOSURE">SNAPSHOT_DISCLOSURE</ac-disclosure>
 *
 * You can also pass in the dcrKey and let the component handle it:
 * <ac-disclosure dcrKey="SNAPSHOT_DISCLOSURE"></ac-disclosure>
 */
export class DisclosureComponent implements OnInit {
	@Input() public isExpandable: boolean = true;
	@Input() public textClass: string = 'text-condensed-14';
	@Input() public dcrKey: string = '';

	public shouldShowDisclosure: boolean = true;
	public isCollapsed: boolean = true;

	constructor(
		private contentService: ContentService,
		private configService: ConfigService
	) { }

	public ngOnInit(): void {
		this.isCollapsed = this.configService.get<boolean>(SharedConfigKey.HAS_COLLAPSED_DISCLOSURE, true);
		if (this.dcrKey) {
			const doesValueExist = !!this.contentService.get(this.dcrKey, '');
			const isShowEditorPresent = window.location.href.includes('showEditor=true');
			const isShowDisclosurePresent = window.location.href.includes('showDisclosure=true');
			this.shouldShowDisclosure = doesValueExist || isShowEditorPresent || isShowDisclosurePresent;
		} else {
			this.shouldShowDisclosure = true;
		}
	}

	/**
	 * Set the isCollapsed flag to expand or collapse disclosure
	 */
	public toggleDisclosure(): void {
		this.isCollapsed = !this.isCollapsed;
	}
}
